import React from 'react';
import { bonuses } from '../data/constants';
export function Bonuses() {
  return <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto" data-id="element-46">
      <div className="text-center mb-12 md:mb-16" data-id="element-47">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-48">
          ⏱️ Pensados para ahorrarte horas
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-49">
          6 Bonos <span className="text-primary" data-id="element-50">Exclusivos</span>
        </h2>
        <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto" data-id="element-51">
          Cada bono te quita una tarea de encima para que resuelvas tu semana en
          minutos, no en horas.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-52">
        {bonuses.map(b => <div key={b.id} className="bg-surface border border-zinc-800 rounded-3xl p-8 flex flex-col hover:border-primary/50 transition-colors" data-id="element-53">
            <div className="text-4xl mb-6" data-id="element-54">{b.icon}</div>
            <h3 className="font-bold text-xl text-white mb-3 leading-tight" data-id="element-55">
              {b.name}
            </h3>
            <p className="text-zinc-400 leading-relaxed" data-id="element-56">{b.desc}</p>
          </div>)}
      </div>
    </section>;
}